import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiAlertTriangle, FiX, FiTrash2 } = FiIcons;

const ExitConfirmationModal = ({ isOpen, onClose, onConfirm, itemCount = 0 }) => {
  if (!isOpen) return null;

  return (
    <AnimatePresence>
      <div className="fixed inset-0 z-[110] flex items-center justify-center p-4">
        {/* Backdrop */}
        <motion.div 
          className="absolute inset-0 bg-gray-900/80 backdrop-blur-sm"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={onClose}
        />

        {/* Modal */}
        <motion.div 
          className="relative z-10 bg-white rounded-[2.5rem] shadow-2xl max-w-md w-full overflow-hidden border border-red-100"
          initial={{ scale: 0.9, opacity: 0, y: 20 }}
          animate={{ scale: 1, opacity: 1, y: 0 }}
          exit={{ scale: 0.9, opacity: 0, y: 20 }}
        >
          {/* Header */}
          <div className="bg-red-50 px-8 py-6 flex items-center justify-between border-b border-red-100">
            <div className="flex items-center gap-3">
              <div className="bg-red-100 p-2.5 rounded-2xl">
                <SafeIcon icon={FiAlertTriangle} className="w-6 h-6 text-red-600" />
              </div>
              <h3 className="text-xl font-black text-gray-900 uppercase tracking-tighter">Destroy Room?</h3>
            </div>
            <button onClick={onClose} className="text-gray-400 hover:text-gray-600 transition-colors">
              <SafeIcon icon={FiX} className="w-6 h-6" />
            </button>
          </div>

          {/* Content */}
          <div className="p-8">
            <div className="space-y-4 mb-8">
              <p className="text-gray-700 font-bold text-lg leading-tight">
                Wait! Leaving will <span className="text-red-600 underline decoration-2 underline-offset-4">permanently destroy</span> this room.
              </p>
              <div className="bg-gray-50 p-4 rounded-2xl border border-gray-100 space-y-3">
                <div className="flex items-center gap-3 text-sm text-gray-600 font-medium">
                  <div className="w-2 h-2 rounded-full bg-red-400" />
                  All {itemCount} shared clips will be deleted
                </div>
                <div className="flex items-center gap-3 text-sm text-gray-600 font-medium">
                  <div className="w-2 h-2 rounded-full bg-red-400" />
                  All other connected users will be logged out
                </div>
                <div className="flex items-center gap-3 text-sm text-gray-600 font-medium">
                  <div className="w-2 h-2 rounded-full bg-red-400" />
                  This action cannot be undone
                </div>
              </div>
            </div>

            <div className="flex flex-col gap-3">
              <motion.button 
                onClick={onConfirm}
                className="w-full py-4 bg-red-600 text-white rounded-2xl font-black shadow-lg shadow-red-200 flex items-center justify-center gap-2 uppercase tracking-widest text-sm"
                whileHover={{ scale: 1.02, backgroundColor: '#dc2626' }}
                whileTap={{ scale: 0.98 }}
              >
                <SafeIcon icon={FiTrash2} className="w-5 h-5" />
                Confirm Destruction
              </motion.button>
              <button 
                onClick={onClose}
                className="w-full py-4 bg-gray-50 text-gray-500 rounded-2xl font-black hover:bg-gray-100 transition-colors uppercase tracking-widest text-xs"
              >
                Stay in Room
              </button>
            </div>
          </div>
        </motion.div>
      </div>
    </AnimatePresence>
  );
};

export default ExitConfirmationModal;